import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

export default function AccountMultipleIcon({ color = "purple" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16 17V19H2V17C2 17 2 13 9 13C16 13 16 17 16 17ZM12.5 7.50001C12.5 6.80777 12.2947 6.13108 11.9101 5.55551C11.5256 4.97994 10.9789 4.53134 10.3394 4.26643C9.69985 4.00152 8.99612 3.93221 8.31718 4.06726C7.63825 4.20231 7.01461 4.53565 6.52513 5.02513C6.03564 5.51462 5.7023 6.13826 5.56725 6.81719C5.4322 7.49612 5.50152 8.19986 5.76642 8.8394C6.03133 9.47894 6.47993 10.0256 7.0555 10.4102C7.63108 10.7947 8.30777 11 9 11C9.92826 11 10.8185 10.6313 11.4749 9.97488C12.1313 9.3185 12.5 8.42826 12.5 7.50001ZM15.94 13C16.5547 13.4758 17.0578 14.0804 17.4137 14.7715C17.7696 15.4626 17.9697 16.2233 18 17V19H22V17C22 17 22 13.37 15.94 13ZM15 4.00001C14.3117 3.99617 13.6385 4.20196 13.07 4.59001C13.6774 5.43874 14.0041 6.45629 14.0041 7.50001C14.0041 8.54372 13.6774 9.56127 13.07 10.41C13.6385 10.7981 14.3117 11.0038 15 11C15.9283 11 16.8185 10.6313 17.4749 9.97488C18.1313 9.3185 18.5 8.42826 18.5 7.50001C18.5 6.57175 18.1313 5.68151 17.4749 5.02513C16.8185 4.36876 15.9283 4.00001 15 4.00001Z"
        fill={COLORS[color]}
      />
    </svg>
  );
}
